import React from "react";
import { STATUS_STYLES } from "../../../utils/filingStatus.js";

const StatusBadge = ({ status }) => {
  const s = STATUS_STYLES[status] || STATUS_STYLES.new;
  return (
    <span
      className="inline-flex items-center gap-1 px-[9px] py-1 rounded-[20px] text-[12px] font-semibold whitespace-nowrap"
      style={{ background: s.bg, color: s.color }}
    >
      {s.label}
    </span>
  );
};

export default StatusBadge;
